// @flow

import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";

const RaceList = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;

  & > li:not(:first-child) {
    border-top: 1px solid ${buildColor("grey", "300")};
  }
`;

export default RaceList;
